import baseApplyEach from "../_internal/baseApplyEach.js";
import map from "./map.js";
import object from "./object.js";

export default baseApplyEach(map, object);
